<template>
  <div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="authRequestorSubmit_tooltip_NAME"  :name="authRequestorSubmit_tooltip_NAME" :description="authRequestorSubmit_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
    <div class="row justify-content-center">
      <div class="col-sm-6 content_padding_top">
        <label for="name"> Name (Last, First, MI, Rank / Title)</label>
        <base-input
          id="name"
          :disabled="isReadOnly || isPartnerAccount"
          data-vv-as="Name"
          v-model="authorizedRequestor.requestorName"
          name="authorizedRequestorName"
          v-validate="'required|max:300'"
          :error="getError('authorizedRequestorName')"
        >
        </base-input>
      </div>
      <div class="col-sm-6 content_padding_top">
        <label for="requestingOffice">Requesting Unit / Office</label>
        <base-input
          id="requestingOffice"
          :disabled="isReadOnly || isPartnerAccount"
          data-vv-as="Requesting Unit / Office"
          v-model="authorizedRequestor.requestorUnitOffice"
          name="requestingUnitOffice"
          v-validate="'required|max:300'"
          :error="getError('requestingUnitOffice')"
        >
        </base-input>
      </div>
      <div class="col-sm-12 content_padding_top">
        <label for="requestingNation">Requesting Nation / Organization</label>
        <v-select
          id="requestingNation"
          :disabled="isReadOnly || isPartnerAccount"
          v-model="authorizedRequestor.requestorOrganizationId"
          :reduce="(organizationOption) => organizationOption.id"
          label="name"
          name="requestingNation"
          data-vv-as="Requesting Nation / Organization"
          :options="authorizedRequestor.organizations"
          placeholder="Select one"
          :class="errors.has('requestingNation') ? 'has-danger' : ''"
          v-validate="'required'"
          :error="getError('requestingNation')"
        >
        </v-select>
         <span v-show="errors.has('requestingNation')" class="error"
          >Requesting Nation / Organization is required
        </span>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-12 content_padding_top">
        <div class="pull-right">
          <base-button
            type="primary"
            wide
            :disabled="isReadOnly || isPartnerAccount"
            @click.native="submit"
            class="btn-next"
            >Save</base-button
          >
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Util from "@/util/util";
import toolTip  from "../../../Tooltip";

export default {
  props: ["isReadOnly"],
  name: "AuthorizedRequestorSubmit",
  components: {
    toolTip
  },
  data() {
    return {
      authRequestorSubmit_tooltip_NAME : '',
      authRequestorSubmit_tooltip_DESCRIPTION : ''
    };
  },
  async mounted(){
    await this.getAllTooltips()
    this.loadToolTips()
  },
  computed: {
    ...mapGetters({
       authorizedRequestor: "authorizedRequestor/authorizedRequestor",
      authorizedRequestorErrors: "authorizedRequestor/authorizedRequestorErrors",
      preOrderStatus: "preOrderDetail/preOrderStatus",
      agreementInformationStatus:"agreementInformation/agreementInformationStatus",
      authorizedRequestorHelper:"authorizedRequestor/authorizedRequestorHelper",
      isPartnerAccount: "authentication/isPartnerAccount",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"
    }),
    getOrderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
  },
  methods: {
    ...mapActions({
      loadAuthorizedRequestor: "authorizedRequestor/getAuthorizedRequestor",
      getAuthorizedRequestorSubmitStatus: "authorizedRequestor/getAuthorizedRequestorSubmitStatus",
      getAuthorizedRequestorHelper:"authorizedRequestor/getAuthorizedRequestorHelper",
      getAllTooltips: "tooltip/getToolTips"
    }),
    loadToolTips(){
    const authRequestorSubmitVal = this.toolTips.find(e => e.name === "AuthRequestorModule")
    if(authRequestorSubmitVal !== undefined && authRequestorSubmitVal.status){
      this.authRequestorSubmit_tooltip_DESCRIPTION = authRequestorSubmitVal.description ? authRequestorSubmitVal.description: null
      this.authRequestorSubmit_tooltip_NAME = authRequestorSubmitVal.name ? authRequestorSubmitVal.name: null
    }
    return 
      
    },
    updateToolTip(updatedData){
      this.loadToolTips()
      },
    async loaded() {
      let ctx = this;

      await ctx.getAuthorizedRequestorHelper(ctx.getOrderIdFromRoute);

      const params = {
        buySell: ctx.authorizedRequestorHelper.buySell,
        countryId: ctx.authorizedRequestorHelper.countryId,
        preOrderDetailStatus: ctx.preOrderStatus,
        agreementInformationStatus: ctx.agreementInformationStatus,
      };

      await ctx.$store.dispatch("authorizedRequestor/getOrganizations", params);
      await ctx.loadAuthorizedRequestor(ctx.getOrderIdFromRoute);
    },
    showAuthorizedRequestorSubmitErrors () {
        if(this.authorizedRequestorErrors.length > 0 ) {
            this.authorizedRequestorErrors.forEach(error => this.$toast.error(error))
        } else {
          this.$toast.success("Authorized Requestor Module saved successfully");
        }
        },
    async submit(e) {
      let result = await this.$validator.validateAll(); //.then((result) => {
      if (result) {
        let ctx = this;
        this.$loaderApp.addRequest();
        let data = {
            orderId: this.getOrderIdFromRoute,
            pin: null
        };
        await this.$store
          .dispatch(
            "authorizedRequestor/saveAuthorizedRequestor",
            data
          )
        await ctx.getAuthorizedRequestorSubmitStatus(ctx.getOrderIdFromRoute);
        ctx.showAuthorizedRequestorSubmitErrors();
        await ctx.loadAuthorizedRequestor(ctx.getOrderIdFromRoute);
        this.$loaderApp.completeRequest();
      
      } else {
        this.$toast.error("Please fill the required fields.");
          this.$loaderApp.completeRequest();
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
};
</script>

<style>
.content_padding_top {
  padding-top: 20px;
}

.content_padding_top_small {
  padding-top: 5px;
}
</style>
